import { CIcon } from '~/icons/types'
export const ciTradesLikes: CIcon = {
  width: 943.4,
  height: 815.3,
  paths: [
    {
      d:
        'M472 815.3h-.5c-23 0-45.4-9.2-61.7-25.4l-.2-.2L77.9 457.6C27.7 406.9 0 339.6 0 268.1c0-71.4 27.7-138.7 77.9-189.5l.2-.2C128.8 27.8 196.2 0 267.8 0s138.9 27.8 189.6 78.4l14.3 14.3L486 78.4C536.7 27.8 604.1 0 675.7 0s138.9 27.8 189.6 78.4l.2.2c50.2 50.8 77.9 118.1 77.9 189.5s-27.7 138.7-77.9 189.5l-.1.1-331.7 332.2c-16.3 16.2-38.8 25.4-61.7 25.4zm-330.2-421 329.9 330.3 329.9-330.3c68.8-69.6 68.8-182.7 0-252.2-69.5-69.2-182.6-69.2-252.1.1L471.7 220l-77.9-77.9c-69.4-69.3-182.5-69.3-252-.1-68.8 69.6-68.7 182.7 0 252.3z'
    }
  ],
  name: 'trades-likes',
  type: 'regular'
}
